export default __webpack_public_path__ + "static/media/1062.c431fb47.png";